import React from 'react';
import _ from "underscore";

// Connections, Connections, connections, connections
const Connections = (props) => {
    if (!props.setRestBlockError) return null;
    const childBlocks = _.values(props.blocks).map((Block, id) => <Block.component context={props.context} setRestBlockError = {props.setRestBlockError} key={id}/>);

    if (childBlocks.length > 0) {
        return (
            <category name='Connections' id='connections' iconclass='category with-icon-paths snap-icon-connection_dual'>
                <label text="Connections"/>
                { childBlocks }
            </category>
        );
    }
    
    return null;
};

export default Connections
